import React from 'react';
import { SvgIcon } from './svg-icon';
export var ShareIcon = function ShareIcon(_a) {
  var className = _a.className;
  return React.createElement(SvgIcon, {
    className: className,
    viewBox: "0 0 32 30"
  }, React.createElement("g", {
    clipPath: "url(#clip0_288_7139)"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9999 9.36146L22.9023 18.4597V13.9272C17.1494 12.7472 12.6049 14.0479 9.15332 18.3801C9.75254 9.47026 15.8999 5.17056 22.902 4.88593L22.9023 0.263184L31.9999 9.36146Z"
  }), React.createElement("path", {
    d: "M1.79896 6.3855H11.0766C9.88203 7.40647 8.80833 8.59323 7.88281 9.94731H3.59766V26.1754H24.588V22.3924L28.1854 18.8914V27.9562C28.1854 28.9395 27.3799 29.7369 26.3867 29.7369H1.79896C0.805469 29.7369 0 28.9395 0 27.9562V8.16627C0 7.18268 0.805469 6.3855 1.79896 6.3855Z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_288_7139"
  }, React.createElement("rect", {
    width: "32",
    height: "29.4737",
    transform: "translate(0 0.263184)"
  }))));
};